import store from "@/store";
export default {
    install(Vue) {
      // Vuex Getters için Helper Methods
      Vue.prototype.$isAdmin = function() {
        return this.store.getters['user/isAdmin'];
      };
  
      Vue.prototype.$isDeveloper = function() {
        return this.store.getters['user/isDeveloper'];
      };
  
      Vue.prototype.$isFenomen = function() {
        return this.store.getters['user/isFenomen'];
      };
  
      Vue.prototype.$userData = function() {
        return this.store.getters['user/userData'];
      };

      Vue.prototype.$globalYears = function() {;
        const currentYear = new Date().getFullYear();
        const createdDate = store.state.user.customerInfo.created_date;
        const createdYear = new Date(createdDate).getFullYear();

        // Yılları oluşturma
        const years = [];
        for (let year = currentYear; year >= createdYear; year--) {
            years.push(String(year));
        }

        return years;
      };
  
      // Tarih Formatlama
      Vue.prototype.$changeFormat = function(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
  
      Vue.prototype.$formatDate = function(dateString, includeYear = true) {
        const date = new Date(dateString);
        const options = {
          day: '2-digit',
          month: 'long',
        };
  
        if (includeYear) {
          options.year = 'numeric';
        }
  
        return new Intl.DateTimeFormat('tr-TR', options).format(date);
      };
  
      // Fiyat Formatlama
      Vue.prototype.$priceFormat = function(val) {
        const numberVal = parseFloat(val);
        if (isNaN(numberVal)) return val;
  
        return numberVal.toLocaleString('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + ' TL';
      };
  
      // Ayların Hesaplanması
      Vue.prototype.$diffDateMonth = function(year) {
        const nowYear = new Date().getFullYear();
        const start = new Date(year, 0, 1);
        const end = nowYear !== year ? new Date(year, 11, 31) : new Date();
  
        const months = [];
        let current = new Date(start);
  
        while (current <= end) {
          const monthName = current.toLocaleString('default', { month: 'long' });
          months.push(monthName);
          current.setMonth(current.getMonth() + 1);
        }
  
        return months;
      };
    },
  };
  